import { render, staticRenderFns } from "./SoliTeacher.vue?vue&type=template&id=88b667ce"
import script from "./SoliTeacher.vue?vue&type=script&lang=js"
export * from "./SoliTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports